import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ a('<path fill="#0052B4" d="M40 20c0-6.864-3.459-12.92-8.728-16.522L20 2.608l-11.272.87C3.458 7.08 0 13.136 0 20c0 6.864 3.459 12.92 8.728 16.522l11.272.87 11.272-.87C36.542 32.92 40 26.864 40 20Z"></path><path fill="#A2001D" d="M31.272 3.478A19.906 19.906 0 0 0 20 0 19.906 19.906 0 0 0 8.728 3.478h22.544ZM8.728 36.522A19.906 19.906 0 0 0 20 40c4.182 0 8.063-1.284 11.272-3.478H8.728Z"></path><path fill="#F0F0F0" d="M20 29.565a9.565 9.565 0 0 0 0-19.13 9.565 9.565 0 1 0 0 19.13Z"></path><path fill="#6DA544" d="M20 27.826a7.826 7.826 0 1 0 0-15.652 7.826 7.826 0 0 0 0 15.652Z"></path><path fill="#F0F0F0" d="M20 25.217a5.217 5.217 0 1 0 0-10.434 5.217 5.217 0 0 0 0 10.434Z"></path><path fill="#0052B4" d="M20 18.696 17.174 20v2.174L20 23.913l2.826-1.74V20L20 18.696Z"></path><path fill="#FFDA44" d="M17.174 17.391h5.652V20h-5.652v-2.609Z"></path>', 7), o = [
  h
];
function p(c, i) {
  return t(), l("svg", e, [...o]);
}
const n = { render: p };
export {
  n as default,
  p as render
};
